/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthTenantsRouteImport } from './routes/_auth.tenants'
import { Route as AuthOverviewRouteImport } from './routes/_auth.overview'
import { Route as AuthBillingRouteImport } from './routes/_auth.billing'
import { Route as AuthAuditLogRouteImport } from './routes/_auth.audit-log'
import { Route as AuthAssistantRouteImport } from './routes/_auth.assistant'
import { Route as AuthAccountSecurityRouteImport } from './routes/_auth.account-security'
import { Route as AuthTenantsIndexRouteImport } from './routes/_auth.tenants.index'
import { Route as AuthBillingIndexRouteImport } from './routes/_auth.billing.index'
import { Route as AuthTenantsNewRouteImport } from './routes/_auth.tenants.new'
import { Route as AuthBillingSubscriptionsRouteImport } from './routes/_auth.billing.subscriptions'
import { Route as AuthBillingPlansRouteImport } from './routes/_auth.billing.plans'
import { Route as AuthBillingMrrRouteImport } from './routes/_auth.billing.mrr'
import { Route as AuthBillingInvoicesRouteImport } from './routes/_auth.billing.invoices'
import { Route as AuthTenantsTenantIdIndexRouteImport } from './routes/_auth.tenants.$tenantId.index'
import { Route as AuthTenantsTenantIdBrandRouteImport } from './routes/_auth.tenants.$tenantId.brand'
import { Route as AuthTenantsTenantIdAssistantRouteImport } from './routes/_auth.tenants.$tenantId.assistant'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTenantsRoute = AuthTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOverviewRoute = AuthOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingRoute = AuthBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditLogRoute = AuthAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssistantRoute = AuthAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountSecurityRoute = AuthAccountSecurityRouteImport.update({
  id: '/account-security',
  path: '/account-security',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTenantsIndexRoute = AuthTenantsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthTenantsRoute,
} as any)
const AuthBillingIndexRoute = AuthBillingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthBillingRoute,
} as any)
const AuthTenantsNewRoute = AuthTenantsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthTenantsRoute,
} as any)
const AuthBillingSubscriptionsRoute =
  AuthBillingSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthBillingRoute,
  } as any)
const AuthBillingPlansRoute = AuthBillingPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthBillingRoute,
} as any)
const AuthBillingMrrRoute = AuthBillingMrrRouteImport.update({
  id: '/mrr',
  path: '/mrr',
  getParentRoute: () => AuthBillingRoute,
} as any)
const AuthBillingInvoicesRoute = AuthBillingInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthBillingRoute,
} as any)
const AuthTenantsTenantIdIndexRoute =
  AuthTenantsTenantIdIndexRouteImport.update({
    id: '/$tenantId/',
    path: '/$tenantId/',
    getParentRoute: () => AuthTenantsRoute,
  } as any)
const AuthTenantsTenantIdBrandRoute =
  AuthTenantsTenantIdBrandRouteImport.update({
    id: '/$tenantId/brand',
    path: '/$tenantId/brand',
    getParentRoute: () => AuthTenantsRoute,
  } as any)
const AuthTenantsTenantIdAssistantRoute =
  AuthTenantsTenantIdAssistantRouteImport.update({
    id: '/$tenantId/assistant',
    path: '/$tenantId/assistant',
    getParentRoute: () => AuthTenantsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/account-security': typeof AuthAccountSecurityRoute
  '/assistant': typeof AuthAssistantRoute
  '/audit-log': typeof AuthAuditLogRoute
  '/billing': typeof AuthBillingRouteWithChildren
  '/overview': typeof AuthOverviewRoute
  '/tenants': typeof AuthTenantsRouteWithChildren
  '/billing/invoices': typeof AuthBillingInvoicesRoute
  '/billing/mrr': typeof AuthBillingMrrRoute
  '/billing/plans': typeof AuthBillingPlansRoute
  '/billing/subscriptions': typeof AuthBillingSubscriptionsRoute
  '/tenants/new': typeof AuthTenantsNewRoute
  '/billing/': typeof AuthBillingIndexRoute
  '/tenants/': typeof AuthTenantsIndexRoute
  '/tenants/$tenantId/assistant': typeof AuthTenantsTenantIdAssistantRoute
  '/tenants/$tenantId/brand': typeof AuthTenantsTenantIdBrandRoute
  '/tenants/$tenantId/': typeof AuthTenantsTenantIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/account-security': typeof AuthAccountSecurityRoute
  '/assistant': typeof AuthAssistantRoute
  '/audit-log': typeof AuthAuditLogRoute
  '/overview': typeof AuthOverviewRoute
  '/': typeof AuthIndexRoute
  '/billing/invoices': typeof AuthBillingInvoicesRoute
  '/billing/mrr': typeof AuthBillingMrrRoute
  '/billing/plans': typeof AuthBillingPlansRoute
  '/billing/subscriptions': typeof AuthBillingSubscriptionsRoute
  '/tenants/new': typeof AuthTenantsNewRoute
  '/billing': typeof AuthBillingIndexRoute
  '/tenants': typeof AuthTenantsIndexRoute
  '/tenants/$tenantId/assistant': typeof AuthTenantsTenantIdAssistantRoute
  '/tenants/$tenantId/brand': typeof AuthTenantsTenantIdBrandRoute
  '/tenants/$tenantId': typeof AuthTenantsTenantIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/account-security': typeof AuthAccountSecurityRoute
  '/_auth/assistant': typeof AuthAssistantRoute
  '/_auth/audit-log': typeof AuthAuditLogRoute
  '/_auth/billing': typeof AuthBillingRouteWithChildren
  '/_auth/overview': typeof AuthOverviewRoute
  '/_auth/tenants': typeof AuthTenantsRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/billing/invoices': typeof AuthBillingInvoicesRoute
  '/_auth/billing/mrr': typeof AuthBillingMrrRoute
  '/_auth/billing/plans': typeof AuthBillingPlansRoute
  '/_auth/billing/subscriptions': typeof AuthBillingSubscriptionsRoute
  '/_auth/tenants/new': typeof AuthTenantsNewRoute
  '/_auth/billing/': typeof AuthBillingIndexRoute
  '/_auth/tenants/': typeof AuthTenantsIndexRoute
  '/_auth/tenants/$tenantId/assistant': typeof AuthTenantsTenantIdAssistantRoute
  '/_auth/tenants/$tenantId/brand': typeof AuthTenantsTenantIdBrandRoute
  '/_auth/tenants/$tenantId/': typeof AuthTenantsTenantIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account-security'
    | '/assistant'
    | '/audit-log'
    | '/billing'
    | '/overview'
    | '/tenants'
    | '/billing/invoices'
    | '/billing/mrr'
    | '/billing/plans'
    | '/billing/subscriptions'
    | '/tenants/new'
    | '/billing/'
    | '/tenants/'
    | '/tenants/$tenantId/assistant'
    | '/tenants/$tenantId/brand'
    | '/tenants/$tenantId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/account-security'
    | '/assistant'
    | '/audit-log'
    | '/overview'
    | '/'
    | '/billing/invoices'
    | '/billing/mrr'
    | '/billing/plans'
    | '/billing/subscriptions'
    | '/tenants/new'
    | '/billing'
    | '/tenants'
    | '/tenants/$tenantId/assistant'
    | '/tenants/$tenantId/brand'
    | '/tenants/$tenantId'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/account-security'
    | '/_auth/assistant'
    | '/_auth/audit-log'
    | '/_auth/billing'
    | '/_auth/overview'
    | '/_auth/tenants'
    | '/_auth/'
    | '/_auth/billing/invoices'
    | '/_auth/billing/mrr'
    | '/_auth/billing/plans'
    | '/_auth/billing/subscriptions'
    | '/_auth/tenants/new'
    | '/_auth/billing/'
    | '/_auth/tenants/'
    | '/_auth/tenants/$tenantId/assistant'
    | '/_auth/tenants/$tenantId/brand'
    | '/_auth/tenants/$tenantId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tenants': {
      id: '/_auth/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof AuthTenantsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/overview': {
      id: '/_auth/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AuthOverviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing': {
      id: '/_auth/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit-log': {
      id: '/_auth/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuthAuditLogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/assistant': {
      id: '/_auth/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AuthAssistantRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account-security': {
      id: '/_auth/account-security'
      path: '/account-security'
      fullPath: '/account-security'
      preLoaderRoute: typeof AuthAccountSecurityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tenants/': {
      id: '/_auth/tenants/'
      path: '/'
      fullPath: '/tenants/'
      preLoaderRoute: typeof AuthTenantsIndexRouteImport
      parentRoute: typeof AuthTenantsRoute
    }
    '/_auth/billing/': {
      id: '/_auth/billing/'
      path: '/'
      fullPath: '/billing/'
      preLoaderRoute: typeof AuthBillingIndexRouteImport
      parentRoute: typeof AuthBillingRoute
    }
    '/_auth/tenants/new': {
      id: '/_auth/tenants/new'
      path: '/new'
      fullPath: '/tenants/new'
      preLoaderRoute: typeof AuthTenantsNewRouteImport
      parentRoute: typeof AuthTenantsRoute
    }
    '/_auth/billing/subscriptions': {
      id: '/_auth/billing/subscriptions'
      path: '/subscriptions'
      fullPath: '/billing/subscriptions'
      preLoaderRoute: typeof AuthBillingSubscriptionsRouteImport
      parentRoute: typeof AuthBillingRoute
    }
    '/_auth/billing/plans': {
      id: '/_auth/billing/plans'
      path: '/plans'
      fullPath: '/billing/plans'
      preLoaderRoute: typeof AuthBillingPlansRouteImport
      parentRoute: typeof AuthBillingRoute
    }
    '/_auth/billing/mrr': {
      id: '/_auth/billing/mrr'
      path: '/mrr'
      fullPath: '/billing/mrr'
      preLoaderRoute: typeof AuthBillingMrrRouteImport
      parentRoute: typeof AuthBillingRoute
    }
    '/_auth/billing/invoices': {
      id: '/_auth/billing/invoices'
      path: '/invoices'
      fullPath: '/billing/invoices'
      preLoaderRoute: typeof AuthBillingInvoicesRouteImport
      parentRoute: typeof AuthBillingRoute
    }
    '/_auth/tenants/$tenantId/': {
      id: '/_auth/tenants/$tenantId/'
      path: '/$tenantId'
      fullPath: '/tenants/$tenantId/'
      preLoaderRoute: typeof AuthTenantsTenantIdIndexRouteImport
      parentRoute: typeof AuthTenantsRoute
    }
    '/_auth/tenants/$tenantId/brand': {
      id: '/_auth/tenants/$tenantId/brand'
      path: '/$tenantId/brand'
      fullPath: '/tenants/$tenantId/brand'
      preLoaderRoute: typeof AuthTenantsTenantIdBrandRouteImport
      parentRoute: typeof AuthTenantsRoute
    }
    '/_auth/tenants/$tenantId/assistant': {
      id: '/_auth/tenants/$tenantId/assistant'
      path: '/$tenantId/assistant'
      fullPath: '/tenants/$tenantId/assistant'
      preLoaderRoute: typeof AuthTenantsTenantIdAssistantRouteImport
      parentRoute: typeof AuthTenantsRoute
    }
  }
}

interface AuthBillingRouteChildren {
  AuthBillingInvoicesRoute: typeof AuthBillingInvoicesRoute
  AuthBillingMrrRoute: typeof AuthBillingMrrRoute
  AuthBillingPlansRoute: typeof AuthBillingPlansRoute
  AuthBillingSubscriptionsRoute: typeof AuthBillingSubscriptionsRoute
  AuthBillingIndexRoute: typeof AuthBillingIndexRoute
}

const AuthBillingRouteChildren: AuthBillingRouteChildren = {
  AuthBillingInvoicesRoute: AuthBillingInvoicesRoute,
  AuthBillingMrrRoute: AuthBillingMrrRoute,
  AuthBillingPlansRoute: AuthBillingPlansRoute,
  AuthBillingSubscriptionsRoute: AuthBillingSubscriptionsRoute,
  AuthBillingIndexRoute: AuthBillingIndexRoute,
}

const AuthBillingRouteWithChildren = AuthBillingRoute._addFileChildren(
  AuthBillingRouteChildren,
)

interface AuthTenantsRouteChildren {
  AuthTenantsNewRoute: typeof AuthTenantsNewRoute
  AuthTenantsIndexRoute: typeof AuthTenantsIndexRoute
  AuthTenantsTenantIdAssistantRoute: typeof AuthTenantsTenantIdAssistantRoute
  AuthTenantsTenantIdBrandRoute: typeof AuthTenantsTenantIdBrandRoute
  AuthTenantsTenantIdIndexRoute: typeof AuthTenantsTenantIdIndexRoute
}

const AuthTenantsRouteChildren: AuthTenantsRouteChildren = {
  AuthTenantsNewRoute: AuthTenantsNewRoute,
  AuthTenantsIndexRoute: AuthTenantsIndexRoute,
  AuthTenantsTenantIdAssistantRoute: AuthTenantsTenantIdAssistantRoute,
  AuthTenantsTenantIdBrandRoute: AuthTenantsTenantIdBrandRoute,
  AuthTenantsTenantIdIndexRoute: AuthTenantsTenantIdIndexRoute,
}

const AuthTenantsRouteWithChildren = AuthTenantsRoute._addFileChildren(
  AuthTenantsRouteChildren,
)

interface AuthRouteChildren {
  AuthAccountSecurityRoute: typeof AuthAccountSecurityRoute
  AuthAssistantRoute: typeof AuthAssistantRoute
  AuthAuditLogRoute: typeof AuthAuditLogRoute
  AuthBillingRoute: typeof AuthBillingRouteWithChildren
  AuthOverviewRoute: typeof AuthOverviewRoute
  AuthTenantsRoute: typeof AuthTenantsRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccountSecurityRoute: AuthAccountSecurityRoute,
  AuthAssistantRoute: AuthAssistantRoute,
  AuthAuditLogRoute: AuthAuditLogRoute,
  AuthBillingRoute: AuthBillingRouteWithChildren,
  AuthOverviewRoute: AuthOverviewRoute,
  AuthTenantsRoute: AuthTenantsRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
